var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"extern",attrs:{"href":_vm.$attrs.href,"target":"_blank"}},[(_vm.$attrs.icon)?_c('b-icon',{staticClass:"mr-1",attrs:{"icon":_vm.$attrs.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }